module.exports = __webpack_public_path__ + "static/media/instagram.bf3609d3.png";